export default __webpack_public_path__ + "static/media/logo1.1b0a80a7.png";